<template>
<div class="col-12 col-md-12 col-lg-6 col-xl-4 py-2">
   <div class="card-wrapper card-space">
      <div class="card card-bg no-after">
         <div class="card card-bg card-with-image no-after">
            <router-link :to="{ name: 'article'+'-'+articolo.area, params: { slug: articolo.slug, id: articolo.id, area: articolo.area, title: articolo.titolo }}">
               <figure>
                  <img class="card-img" :src="articolo.image[0].immagine+'&q=75&w=480'" :alt="articolo.image[0].didascalia"/>
                  <figcaption>{{articolo.titolo}}</figcaption>
               </figure>  
            </router-link>     
         </div>
         <div v-if="arguments !== undefined && arguments !== null" class="py-2 px-2">
            <span v-for="argument in arguments" :key="argument.id" :tag="argument.nome" :linkHref="argument.linkUrl">
               <argomento v-if="argument.nome !== undefined"  :tag="argument.nome" :linkHref="argument.linkUrl"/>
            </span>            
         </div>
      </div>

   </div>
</div>
</template>
<script>
import argomento from "@/components/Arguments.vue";

export default {
   name: "imgcard",
   
   components: {
      argomento
   },

   data() {
      return {
         arguments: null,
      }         
   },  

   props: {   
      id: {
         type: String,
         description: "Image"
      },
      articolo: {
         type: Object,
         description: "Article"
      },   
   },

   mounted() {
      this.arguments = this.$root.getS3Category(this.$props.articolo.s3);
   },

   computed:{
      link: function () {
         return this.$route.path + '/' + this.$props.articolo.slug;
      }
   }   
};
</script>
<style>
   .card-with-image figure{margin:0px;}
   .card-with-image figcaption{background:rgba(0,0,0,0.5); padding:1.0rem; position: absolute; width:100%; bottom:1rem; color:#FFF;}
</style>
